import React, { useState, useEffect, useRef } from "react";
import {
  FormContainer,
  Label,
  CardBody,
  Select,
  Button,
} from "components/ConfigHotel/StyledCard";
import {
  Input,
  FormGroup,
} from "pages/Admin/DashboardAdmin/HotelConfig/Hotel/StyledHotel";
import defaultImage from "image/defaultImage.svg";
import { ButtonRow } from "pages/Admin/DashboardAdmin/HotelConfig/Hotel/StyledHotel";
import { toast } from "react-toastify";
import { useUpdateCharteGraphiqueMutation } from "actions/CharteGraphic/mutations";

const Cardcomponent = ({ selectedHotel }) => {
  const [imageSrc, setImageSrc] = useState(defaultImage);
  const [hotelName, setHotelName] = useState(selectedHotel?.nom_hotel || "");
  const [loading, setLoading] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState({
    logo_principal: "",
    logo_email_confirmation: "",
    logo_email_promotion: "",
    logo_email_bienvenue: "",
  });

  const [updateCharteGraphique] = useUpdateCharteGraphiqueMutation();

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    if (selectedHotel?.nom_hotel !== hotelName) {
      setHotelName(selectedHotel?.nom_hotel || "");
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (selectedHotel) {
      setSelectedImages("logo_principal", selectedHotel?.chart_graphique?.logo_principal || "");
      setSelectedImages("logo_email_confirmation", selectedHotel?.chart_graphique?.logo_email_confirmation || "");
      setSelectedImages("logo_email_promotion", selectedHotel?.chart_graphique?.logo_email_promotion || "");
      setSelectedImages("logo_email_bienvenue", selectedHotel?.chart_graphique?.logo_email_bienvenue || "");
    }
  }, [selectedHotel]);

  console.log(selectedHotel?.chart_graphique)

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newImages = Array.from(files).map((file) => {
      return { name: file.name, file };
    });
    setUploadedImages((prev) => [...prev, ...newImages]);

    const reader = new FileReader();
    reader.onload = (e) => {
      setImageSrc(e.target.result);
    };
    reader.readAsDataURL(newImages[0].file);

    if (newImages.length > 0) {
      setSelectedImages((prev) => ({
        ...prev,
        logo_principal: newImages[0].name,
      }));
    }
  };

  const handleSelectChanges = (event) => {
    const { name, value } = event.target;
    const selectedImage = uploadedImages.find((img) => img.name === value);
    if (selectedImage) {
      setImageSrc(URL.createObjectURL(selectedImage.file));
      setSelectedImages((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(name);

    setHotelName(value);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataToSend = new FormData();
    // Append the selected images files
    formDataToSend.append(
      "logo_principal",
      uploadedImages.find((img) => img.name === selectedImages.logo_principal)?.file || ""
    );
    formDataToSend.append(
      "logo_email_confirmation",
      uploadedImages.find((img) => img.name === selectedImages.logo_confirmation)?.file || ""
    );
    formDataToSend.append(
      "logo_email_bienvenue",
      uploadedImages.find((img) => img.name === selectedImages.logo_bienvenue)?.file || ""
    );
    formDataToSend.append(
      "logo_email_promotion",
      uploadedImages.find((img) => img.name === selectedImages.logo_promotion)?.file || ""
    );


    try {
      const chartGraphiqueId = selectedHotel.chart_graphique.id;
      await updateCharteGraphique({
        id: chartGraphiqueId,
        hotelierData: formDataToSend,
      });
      toast.success("Logos de charte graphique mis à jour avec succès");
    } catch (error) {
      toast.error("Error updating charte graphique: " + error.message);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
      <div className="card-body">
        <FormContainer>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Nom de l'hôtel</Label>
                <Input
                  type="text"
                  name="nom_hotel"
                  value={hotelName}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup className="mt-3">
                <Label>Logo principal de l'hôtel</Label>
                <Select
                  name="logo_principal"
                  onChange={handleSelectChanges}
                  value={selectedImages.logo_principal}
                >
                  <option value="">Sélectionner une image</option>
                  {uploadedImages.map((image, index) => (
                    <option key={index} value={image.name}>
                      {image.name}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup className="mt-3">
                <Label>Logo e-mail de confirmation</Label>
                <Select
                  name="logo_confirmation"
                  onChange={handleSelectChanges}
                  value={selectedImages.logo_confirmation}
                >
                  <option value="">Sélectionner une image</option>
                  {uploadedImages.map((image, index) => (
                    <option key={index} value={image.name}>
                      {image.name}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup className="mt-3">
                <Label>Logo e-mail Email de promotion</Label>
                <Select
                  name="logo_promotion"
                  onChange={handleSelectChanges}
                  value={selectedImages.logo_promotion}
                >
                  <option value="">Sélectionner une image</option>
                  {uploadedImages.map((image, index) => (
                    <option key={index} value={image.name}>
                      {image.name}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup className="mt-3">
                <Label>Logo e-mail de bienvenue</Label>
                <Select
                  name="logo_bienvenue"
                  onChange={handleSelectChanges}
                  value={selectedImages.logo_bienvenue}
                >
                  <option value="">Sélectionner une image</option>
                  {uploadedImages.map((image, index) => (
                    <option key={index} value={image.name}>
                      {image.name}
                    </option>
                  ))}
                </Select>
              </FormGroup>
            </div>
            <div className="col-md-6">
              <CardBody>
                <div>
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    multiple
                  />
                  <Button
                    type="button"
                    className="btn"
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    Télécharger vos fichiers
                  </Button>
                </div>
                <div style={{ border: "1px solid dotted", marginTop: "20px" }}>
                  <img
                    src={imageSrc}
                    alt="Uploaded"
                    style={{ width: "100%" }}
                  />
                </div>
              </CardBody>
            </div>
            <ButtonRow>
              <button type="button" className="btn">
                Annuler
              </button>
              <button type="button" className="btn" onClick={handleSave} disabled={loading}>
                {loading ? "Chargement..." : "Sauvegarder"}
              </button>
            </ButtonRow>
          </div>
        </FormContainer>
      </div>
    </div>
  );
};

export default Cardcomponent;
